import React from "react";
import {
    TextField,
    MenuItem,
    Grid,
    Select,
    InputLabel,
    FormControl,
} from "@mui/material";
import GenericAddButton from "widgets/GenericAddButton/GenericAddButton";
import SearchIcon from "@mui/icons-material/Search";

const FiltroNetPay = ({ handleSubmit, onSubmit, register, errors }) => {
    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={1} alignItems="center">
                <Grid item xs={12} lg={2}>
                    <TextField
                        fullWidth
                        label="*Desde"
                        type="date"
                        {...register("from_date")}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        error={!!errors.from_date}
                        helperText={errors.from_date?.message}
                    />
                </Grid>
                <Grid item xs={12} lg={2}>
                    <TextField
                        fullWidth
                        label="*Hasta"
                        type="date"
                        {...register("to_date")}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        error={!!errors.to_date}
                        helperText={errors.to_date?.message}
                    />
                </Grid>
                <Grid item xs={12} lg={2}>
                    <TextField
                        fullWidth
                        label="*Referencia"
                        {...register("reference")}
                        error={!!errors.reference}
                        helperText={errors.reference?.message}
                    />
                </Grid>

                <Grid item xs={12} lg={2}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                            Tipo de transacción
                        </InputLabel>
                        <Select
                            fullWidth
                            {...register("payment_type_id")}
                            error={!!errors.payment_type_id}
                            helperText={errors.payment_type_id?.message}
                        >
                            <MenuItem value={1}>Prepago</MenuItem>
                            <MenuItem value={3}>Compra de SIM</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} lg={2}>
                    <TextField
                        fullWidth
                        label="*Clave STP"
                        {...register("beneficiary_account")}
                        error={!!errors.beneficiary_account}
                        helperText={errors.beneficiary_account?.message}
                    />
                </Grid>

                <Grid item xs={12} lg={1}>
                    <TextField
                        fullWidth
                        label="Monto"
                        type="number"
                        {...register("amount")}
                        error={!!errors.amount}
                        helperText={errors.amount?.message}
                        onWheel={(e) => e.target.blur()}
                    />
                </Grid>

                <Grid item xs={12} lg={1}>
                    <GenericAddButton
                        buttonText="Buscar"
                        backgroundColor="#4C2484"
                        size="medium"
                        isSubmit
                        icon={<SearchIcon />}
                    />
                </Grid>
            </Grid>
        </form>
    );
};

export default FiltroNetPay;
